export const performance = {
  now: (): number => {
    return window.performance.now()
  },
}
